<script>
import Breadcrumb from '@/src/components/Breadcrumb.vue'
import PageHeader from '@/src/components/PageHeader.vue'
import DataModeVuetablePagination from '@components/DataModeVuetablePagination'
import Layout from '@layouts/main'
import { authComputed } from '@state/helpers'

import { faHome, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { Map, Marker, gmapApi } from 'gmap-vue'

import DailyUserRouteService from '@src/services/dashboards/DailyUserRouteService'

import multiSelectWithService from '@src/components/multiSelectWithService'
import filterVuetable from '@src/mixins/filterVuetable'
import vuetableFormatter from '@src/mixins/vuetableFormatters'

import DatePicker from '@/src/components/DatePicker'
import FilterButton from '@/src/components/FilterButton'
import DirectionsRenderer from '@src/components/map/directionsRenderer'
import trackMapModal from '@src/router/views/dashboards/trackMap/trackMapModal'
// import cloneObject from '@utils/clone-object'
import exportKmModal from '@/src/router/views/dashboards/workSchedulesMap/exportKmModal'
import { orderBy, round } from 'lodash'
import moment from 'moment'

const i18nKey = 'DASHBOARDS'
const i18nCommon = 'COMMON'

export default {
    components: {
        Layout,
        Breadcrumb,
        PageHeader,
        DataModeVuetablePagination,
        'gmap-map': Map,
        GmapMarker: Marker,
        DatePicker,
        multiSelectWithService,
        DirectionsRenderer,
        FilterButton,
        trackMapModal,
        exportKmModal,
    },
    mixins: [filterVuetable, vuetableFormatter],
    data() {
        return {
            i18nKey,
            i18nCommon,
            loading: true,
            center: {
                lat: -25.4269067,
                lng: -49.2427093,
            },
            posMarker: {
                path: faMapMarkerAlt.icon[4],
                scale: 0.07,
                fillColor: '#808895',
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
            },
            posVisitedMarker: {
                path: faMapMarkerAlt.icon[4],
                scale: 0.07,
                fillColor: '#2E7FEB',
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
            },
            // checkInMarker: {
            //     path: faSignInAlt.icon[4],
            //     scale: 0.07,
            //     fillColor: '#89E09C',
            //     fillOpacity: 1,
            //     strokeWeight: 0,
            //     rotation: 0,
            // },
            homeMarker: {
                path: faHome.icon[4],
                scale: 0.07,
                fillColor: '#ed6112',
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
            },
            usersParameters: {
                per_page: 1000,
                page: 1,
                orderBy: 'name',
                sortedBy: 'asc',
                active: true,
            },
            filters: {
                date: new Date(),
                user: null,
            },
            user: null,
            workSchedules: [],
            pointOfSalesWithLocation: [],
            pointOfSalesWithoutLocation: [],
            posChecks: [],
            posChecksRoute: [],
            predictedRouteForMap: [],
            performedRouteForMap: [],
            predictedRouteResponse: null,
            performedRouteResponse: null,
            showPredictedRoute: true,
            showPerformedRoute: true,
            boundsUpdateTimeout: null,
            additionalParameters: {},
            userPosition: null,
            totalPredicted: {
                distance: 0,
                duration: 0,
            },
            totalPerformed: {
                distance: 0,
                duration: 0,
            },
            workSchedulesFields: [
                {
                    name: 'pointOfSale.name',
                    title: this.getI18n('POS', 'TITLES.pos'),
                    sortField: 'pointOfSale.name',
                },
                {
                    name: 'pointOfSale.long_name',
                    title: this.getI18n(i18nCommon, 'address'),
                    sortField: 'pointOfSale.long_name',
                },
                // {
                //     name: 'distance_from_last_point',
                //     title: this.getI18n(i18nKey, 'TITLES.distance_from_last_point'),
                //     sortField: 'distance_from_last_point',
                // },
                {
                    name: 'distance_performed',
                    title: this.getI18n(i18nKey, 'TITLES.distance_performed'),
                    sortField: 'distance_performed',
                },
                {
                    name: 'accomplished',
                    title: this.getI18n(i18nKey, 'TITLES.accomplished'),
                    formatter: this.booleanIcons,
                    sortField: 'accomplished',
                },
                {
                    name: 'photo_checkin',
                    title: this.getI18n(i18nKey, 'TITLES.photo_checkin'),
                },
                // {
                //     name: 'pointOfSale.long_name',
                //     title: this.getI18nModified({
                //         prefix: i18nCommon,
                //         suffix: 'detail',
                //         modifier: 2,
                //     }),
                // },
            ]
        }
    },
    computed: {
        items() {
            return [
                {
                    text: 'Home',
                    href: '/',
                },
                {
                    text: this.getI18nModified({
                        prefix: i18nKey,
                        suffix: 'TITLES.dashboards',
                        modifier: 2,
                    }),
                    active: true,
                },
                {
                    text: this.i18nDailyRoute,
                    active: true,
                },
            ]
        },
        ...authComputed,
        google: gmapApi,
        i18nDailyRoute() {
            return this.getI18n(i18nCommon, 'daily_route')
        },
        i18nDate() {
            return this.getI18n(i18nCommon, 'date')
        },
        i18nUser() {
            return this.getI18n('USERS', 'TITLES.user')
        },
        i18nMinutes() {
            return this.$options.filters.firstToLower(
                this.getI18nModified({
                    prefix: i18nCommon,
                    suffix: 'minutes',
                    modifier: 2,
                })
            )
        },
    },
    async mounted() {
        this.filters.user = this.userLoggedIn
        this.filter()
    },
    methods: {
        refreshTable() {
        },
        showExportKmModal() {
            this.$refs.exportKmModal.showModal()
        },
        createParameters() {
            this.userPosition = this.filters.user ?
            {
                lat: this.filters.user.lat,
                lng: this.filters.user.long,
            } : null

            return this.formatParameters({
                user_id: this.filters.user.id,
                date: this.dateToValue(this.filters.date),
            })
        },
        panTo(lat, lng) {
            this.$refs.gmap.$mapPromise.then((map) => {
                var latLng = new this.google.maps.LatLng(lat, lng)
                map.panTo(latLng)
            })
        },
        scheduleBoundsUpdate() {
            // Debounce para evitar múltiplas chamadas
            if (this.boundsUpdateTimeout) {
                clearTimeout(this.boundsUpdateTimeout)
            }
            this.boundsUpdateTimeout = setTimeout(() => {
                this.mapBounds()
            }, 300)
        },
        mapBounds() {
            this.$refs.gmap.$mapPromise.then((map) => {
                const bounds = new this.google.maps.LatLngBounds()
                let hasPoints = false

                // Adicionar bounds da rota prevista se visível
                if (this.showPredictedRoute && this.predictedRouteResponse) {
                    const route = this.predictedRouteResponse.routes[0]
                    if (route) {
                        // Usar o bounds já calculado pela API (mais preciso)
                        if (route.bounds) {
                            bounds.union(route.bounds)
                            hasPoints = true
                        }
                        // Fallback: usar overview_path (todos os pontos da polilinha)
                        else if (route.overview_path && route.overview_path.length > 0) {
                            route.overview_path.forEach(point => {
                                bounds.extend(point)
                                hasPoints = true
                            })
                        }
                        // Fallback: usar todos os pontos de todos os legs
                        else if (route.legs && route.legs.length > 0) {
                            route.legs.forEach(leg => {
                                // Adicionar início e fim de cada leg
                                if (leg.start_location) {
                                    bounds.extend(leg.start_location)
                                    hasPoints = true
                                }
                                if (leg.end_location) {
                                    bounds.extend(leg.end_location)
                                    hasPoints = true
                                }
                                // Adicionar todos os steps de cada leg (caminho completo)
                                if (leg.steps && leg.steps.length > 0) {
                                    leg.steps.forEach(step => {
                                        if (step.path && step.path.length > 0) {
                                            step.path.forEach(point => {
                                                bounds.extend(point)
                                                hasPoints = true
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    }
                }

                // Adicionar bounds da rota realizada se visível
                if (this.showPerformedRoute && this.performedRouteResponse) {
                    const route = this.performedRouteResponse.routes[0]
                    if (route) {
                        // Usar o bounds já calculado pela API (mais preciso)
                        if (route.bounds) {
                            bounds.union(route.bounds)
                            hasPoints = true
                        }
                        // Fallback: usar overview_path (todos os pontos da polilinha)
                        else if (route.overview_path && route.overview_path.length > 0) {
                            route.overview_path.forEach(point => {
                                bounds.extend(point)
                                hasPoints = true
                            })
                        }
                        // Fallback: usar todos os pontos de todos os legs
                        else if (route.legs && route.legs.length > 0) {
                            route.legs.forEach(leg => {
                                // Adicionar início e fim de cada leg
                                if (leg.start_location) {
                                    bounds.extend(leg.start_location)
                                    hasPoints = true
                                }
                                if (leg.end_location) {
                                    bounds.extend(leg.end_location)
                                    hasPoints = true
                                }
                                // Adicionar todos os steps de cada leg (caminho completo)
                                if (leg.steps && leg.steps.length > 0) {
                                    leg.steps.forEach(step => {
                                        if (step.path && step.path.length > 0) {
                                            step.path.forEach(point => {
                                                bounds.extend(point)
                                                hasPoints = true
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    }
                }

                // Se nenhuma rota está visível ou disponível, usar os marcadores como fallback
                if (!hasPoints) {
                    if (this.pointOfSalesWithLocation.length > 0) {
                        for (let i = 0; i < this.pointOfSalesWithLocation.length; i++) {
                            bounds.extend(
                                new this.google.maps.LatLng(
                                    this.pointOfSalesWithLocation[i].position.lat,
                                    this.pointOfSalesWithLocation[i].position.lng
                                )
                            )
                            hasPoints = true
                        }
                    }
                    if (this.posChecks.length > 0) {
                        for (let i = 0; i < this.posChecks.length; i++) {
                            bounds.extend(
                                new this.google.maps.LatLng(
                                    this.posChecks[i].position.lat,
                                    this.posChecks[i].position.lng
                                )
                            )
                            hasPoints = true
                        }
                    }
                }

                // Adicionar casa do usuário se disponível
                if (this.userPosition && this.userPosition.lat && this.userPosition.lng) {
                    bounds.extend(
                        new this.google.maps.LatLng(
                            this.userPosition.lat,
                            this.userPosition.lng
                        )
                    )
                    hasPoints = true
                }

                if (hasPoints) {
                    // Usar fitBounds com padding para melhor visualização
                    map.fitBounds(bounds, {
                        top: 50,
                        right: 50,
                        bottom: 50,
                        left: 50
                    })
                }
            })
        },
        async filter() {
            this.additionalParameters = this.createParameters()
            this.user = this.filters.user
            await this.getDailyRoute()
        },
        async getDailyRoute() {
            this.loading = true
            await DailyUserRouteService.fetchAll(this.additionalParameters)
                .then((response) => {
                    const remoteWorkSchedules = response.data.data.work_schedules.filter((workSchedule) => workSchedule.pointOfSale.location[0] !== null && workSchedule.pointOfSale.location[1] !== null);
                    this.pointOfSalesWithoutLocation = response.data.data.work_schedules.filter((workSchedule) => workSchedule.pointOfSale.location[0] === null || workSchedule.pointOfSale.location[1] === null);

                    this.pointOfSalesWithLocation = response.data.data.pos_with_location.map(
                        (pos) => {
                            return this.mapLocation(pos, 'location')
                        }
                    )

                    this.posChecks = response.data.data.pos_checks.map(
                        (posCheck) => {
                            return this.mapLocation(posCheck, 'location_in')
                        }
                    )

                    console.log(remoteWorkSchedules);

                    const workSchedules = []
                    for (var y = 0; y < remoteWorkSchedules.length; y++) {
                        const posCheck = this.posChecks.find((posCheck) => posCheck.point_of_sale_id === remoteWorkSchedules[y].point_of_sale_id)

                        if (workSchedules.find((workSchedule) => workSchedule.point_of_sale_id === remoteWorkSchedules[y].point_of_sale_id)) {
                            continue
                        }

                        workSchedules.push({
                            ...remoteWorkSchedules[y],
                            accomplished: !!(posCheck && posCheck.datetime_out),
                            photo_checkin: posCheck && posCheck.file ? posCheck.file : null,
                            datetime_in: posCheck && posCheck.datetime_in ? moment(posCheck.datetime_in, 'YYYY-MM-DD HH:mm:ss').toDate() : null,
                            distance_from_last_point: 0,
                            distance_performed: 0,
                        })
                    }
                    this.workSchedules = orderBy(workSchedules, ['datetime_in'], ['asc'])

                    if (this.workSchedules.length > 0) {
                        if (this.userPosition && this.userPosition.lat && this.userPosition.lng) {
                            const userHouse = {
                                pointOfSale: {
                                    name: 'CASA',
                                    location: [this.userPosition.lat, this.userPosition.lng]
                                },
                                accomplished: false,
                                photo_checkin: false,
                                datetime_in: null,
                                distance_from_last_point: 0,
                                distance_performed: 0,
                            };
                            this.workSchedules.unshift({
                                id: -1,
                                ...userHouse
                            })
                            this.workSchedules.push({
                                id: 0,
                                ...userHouse
                            })
                        }
                    }

                    // Construir rota prevista para o mapa
                    this.predictedRouteForMap = []
                    const predictedRoute = this.buildPredictedRoute()
                    for (let i = 0; i < predictedRoute.length - 1; i++) {
                        const posOrigin = predictedRoute[i]
                        const posDestination = predictedRoute[i + 1]
                        if (posOrigin && posDestination) {
                            this.predictedRouteForMap.push({
                                id: `predicted_${posOrigin.id}_${i}`,
                                origin: posOrigin.location,
                                destination: posDestination.location,
                            })
                        }
                    }

                    // Construir rota realizada para o mapa
                    this.performedRouteForMap = []
                    const performedRoute = this.buildPerformedRoute()
                    for (let i = 0; i < performedRoute.length - 1; i++) {
                        const posOrigin = performedRoute[i]
                        const posDestination = performedRoute[i + 1]
                        if (posOrigin && posDestination) {
                            this.performedRouteForMap.push({
                                id: `performed_${posOrigin.id}_${i}`,
                                origin: posOrigin.location,
                                destination: posDestination.location,
                            })
                        }
                    }

                    // Manter posChecksRoute para compatibilidade (usando rota prevista)
                    this.posChecksRoute = this.predictedRouteForMap

                    // Resetar respostas das rotas
                    this.predictedRouteResponse = null
                    this.performedRouteResponse = null

                    this.getGmapRoute(false)
                    this.getGmapRoute(true)

                    this.$nextTick(() => {
                        this.$refs.relationVuetable.refresh()
                    })

                    this.loading = false
                    return response
                })
                .catch((err) => {
                    this.loading = false
                    return err
                })

            // mapBounds será chamado após as rotas serem calculadas
        },
        mapLocation(posCheck, field) {
            if (!posCheck[field]) {
                return null
            }
            posCheck.position = this.latLngFromArray(posCheck[field])
            return posCheck
        },
        latLngFromArray(position) {
            return {
                lat: position[0],
                lng: position[1],
            }
        },
        buildPredictedRoute() {
            const route = []
            const allWorkSchedules = this.workSchedules.filter(ws =>
                ws.id !== -1 && ws.id !== 0 && ws.pointOfSale && ws.pointOfSale.location
            )

            if (this.userPosition && this.userPosition.lat && this.userPosition.lng) {
                route.push({
                    id: -1,
                    location: this.userPosition
                })
            }

            allWorkSchedules.forEach(ws => {
                route.push({
                    id: ws.id,
                    location: this.latLngFromArray(ws.pointOfSale.location)
                })
            })

            if (this.userPosition && this.userPosition.lat && this.userPosition.lng) {
                route.push({
                    id: 0,
                    location: this.userPosition
                })
            }

            return route
        },
        buildPerformedRoute() {
            const route = []
            const visitedWorkSchedules = this.workSchedules
                .filter(ws =>
                    ws.id !== -1 &&
                    ws.id !== 0 &&
                    ws.accomplished &&
                    ws.pointOfSale &&
                    ws.pointOfSale.location &&
                    ws.datetime_in
                )
                .sort((a, b) => {
                    if (!a.datetime_in || !b.datetime_in) return 0
                    return new Date(a.datetime_in) - new Date(b.datetime_in)
                })

            if (this.userPosition && this.userPosition.lat && this.userPosition.lng) {
                route.push({
                    id: -1,
                    location: this.userPosition
                })
            }

            visitedWorkSchedules.forEach(ws => {
                route.push({
                    id: ws.id,
                    location: this.latLngFromArray(ws.pointOfSale.location)
                })
            })

            if (this.userPosition && this.userPosition.lat && this.userPosition.lng) {
                route.push({
                    id: 0,
                    location: this.userPosition
                })
            }

            return route
        },
        toggleInfoWindow(marker) {
            const filter = {
                userId: this.filters.user.id,
                dateTimeIn: {
                    start: this.dateToValue(this.filters.date),
                    end: this.dateToValue(this.filters.date),
                },
                pointOfSaleId: marker.id,
            }
            this.$nextTick(() => this.$refs.trackModal.showModal(filter))
        },
        getGmapRoute(predictedRoute) {
            const route = predictedRoute ? this.buildPredictedRoute() : this.buildPerformedRoute()

            if (route.length < 2) {
                return
            }

            const waypoints = []
            for (let i = 1; i < route.length - 1; i++) {
                if (route[i]) {
                    waypoints.push({
                        location: route[i].location,
                        stopover: true,
                    })
                }
            }

            if (predictedRoute) {
                this.totalPredicted = {
                    distance: 0,
                    duration: 0,
                }
            } else {
                this.totalPerformed = {
                    distance: 0,
                    duration: 0,
                }
            }

            const service = new this.google.maps.DirectionsService();
            service.route({
                origin: route[0].location,
                waypoints: waypoints,
                destination: route[route.length - 1].location,
                provideRouteAlternatives: false,
                optimizeWaypoints: predictedRoute,
                travelMode: 'DRIVING',
            }, (response, status) => {
                if (status === 'OK') {
                    if (response.routes && response.routes.length > 0) {
                        if (response.routes[0].legs && response.routes[0].legs.length > 0) {
                            const legs = response.routes[0].legs;
                            const waypointOrder = response.routes[0].waypoint_order || null;

                            if (predictedRoute) {
                                let totalDistance = 0
                                let totalDuration = 0

                                legs.forEach(leg => {
                                    totalDistance += leg.distance.value ?? 0
                                    totalDuration += leg.duration.value ?? 0
                                })

                                this.totalPredicted.distance = totalDistance
                                this.totalPredicted.duration = totalDuration
                                this.predictedRouteResponse = response

                                // Atualizar bounds apenas quando ambas as rotas estiverem prontas ou quando não houver rota realizada
                                if (!this.performedRouteForMap.length || this.performedRouteResponse) {
                                    this.scheduleBoundsUpdate()
                                }

                                const hasHomeAtStart = route[0] && route[0].id === -1
                                const hasHomeAtEnd = route[route.length - 1] && route[route.length - 1].id === 0

                                if (waypointOrder && waypointOrder.length > 0) {
                                    // Construir rota otimizada: origem + waypoints otimizados + destino
                                    const optimizedRoute = []

                                    // Adicionar origem (casa inicial se existir)
                                    if (hasHomeAtStart) {
                                        optimizedRoute.push(route[0])
                                    }

                                    // Adicionar waypoints na ordem otimizada
                                    waypointOrder.forEach(waypointIndex => {
                                        // waypointIndex é o índice no array de waypoints originais
                                        // Se há casa no início, waypoints começam em route[1]
                                        const routeIndex = hasHomeAtStart ? waypointIndex + 1 : waypointIndex
                                        optimizedRoute.push(route[routeIndex])
                                    })

                                    // Adicionar destino (casa final se existir)
                                    if (hasHomeAtEnd) {
                                        optimizedRoute.push(route[route.length - 1])
                                    }

                                    // Mapear distâncias dos legs para os PDVs na ordem otimizada
                                    for (let i = 0; i < optimizedRoute.length - 1; i++) {
                                        const nextPoint = optimizedRoute[i + 1]
                                        const leg = legs[i]

                                        if (nextPoint && nextPoint.id !== undefined) {
                                            if (nextPoint.id === 0) {
                                                // CASA final - último leg (retorno para casa)
                                                const ws = this.workSchedules.find(ws => ws.id === 0)
                                                if (ws) {
                                                    ws.distance_from_last_point = leg?.distance.value ?? 0
                                                }
                                            } else if (nextPoint.id !== -1) {
                                                const ws = this.workSchedules.find(ws => ws.id === nextPoint.id)
                                                if (ws) {
                                                    ws.distance_from_last_point = leg?.distance.value ?? 0
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    // Sem otimização, usar ordem original
                                    for (let i = 0; i < route.length - 1; i++) {
                                        const nextPoint = route[i + 1]
                                        const leg = legs[i]

                                        if (nextPoint && nextPoint.id !== undefined) {
                                            if (nextPoint.id === 0) {
                                                // CASA final - último leg (retorno para casa)
                                                const ws = this.workSchedules.find(ws => ws.id === 0)
                                                if (ws) {
                                                    ws.distance_from_last_point = leg?.distance.value ?? 0
                                                }
                                            } else if (nextPoint.id !== -1) {
                                                const ws = this.workSchedules.find(ws => ws.id === nextPoint.id)
                                                if (ws) {
                                                    ws.distance_from_last_point = leg?.distance.value ?? 0
                                                }
                                            }
                                        }
                                    }
                                }
                            } else {
                                let totalDistance = 0
                                let totalDuration = 0

                                legs.forEach(leg => {
                                    totalDistance += leg.distance.value ?? 0
                                    totalDuration += leg.duration.value ?? 0
                                })

                                this.totalPerformed.distance = totalDistance
                                this.totalPerformed.duration = totalDuration
                                this.performedRouteResponse = response

                                // Atualizar bounds apenas quando ambas as rotas estiverem prontas ou quando não houver rota prevista
                                if (!this.predictedRouteForMap.length || this.predictedRouteResponse) {
                                    this.scheduleBoundsUpdate()
                                }

                                const visitedWorkSchedules = this.workSchedules
                                    .filter(ws => ws.accomplished && ws.id !== -1 && ws.id !== 0)
                                    .sort((a, b) => {
                                        if (!a.datetime_in || !b.datetime_in) return 0
                                        return new Date(a.datetime_in) - new Date(b.datetime_in)
                                    })

                                const hasHomeAtStart = this.userPosition && this.userPosition.lat && this.userPosition.lng
                                const hasHomeAtEnd = this.userPosition && this.userPosition.lat && this.userPosition.lng

                                for (let i = 0; i < visitedWorkSchedules.length; i++) {
                                    const ws = visitedWorkSchedules[i]
                                    const legIndex = hasHomeAtStart ? i : i
                                    if (legs[legIndex]) {
                                        ws.distance_performed = legs[legIndex].distance.value ?? 0
                                    } else {
                                        ws.distance_performed = 0
                                    }
                                }

                                // Atribuir distância do retorno para casa (último leg) à CASA final
                                if (hasHomeAtEnd && legs.length > 0) {
                                    const lastLeg = legs[legs.length - 1]
                                    const casaFinal = this.workSchedules.find(ws => ws.id === 0)
                                    if (casaFinal && lastLeg) {
                                        casaFinal.distance_performed = lastLeg.distance.value ?? 0
                                    }
                                }
                            }
                        }
                    }
                }
            });
        },
        lodashRound(value, precision) {
            return round(value, precision)
        },
    },
}
</script>

<template>
    <Layout>
        <div class="col-12">
            <Breadcrumb :items="items" />
            <div class="row mt-3 mb-3">
                <div class="col-sm-8">
                    <b-row>
                        <b-col md="5">
                            <b-form-group
                                :label="i18nDate"
                                class="required label-pdv"
                                label-for="filter-date"
                            >
                                <date-picker
                                    :value.sync="filters.date"
                                    :max-date="new Date()"
                                    :disable-clean-button="true"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group
                                :label="i18nUser"
                                class="label-pdv"
                                label-for="filter-user"
                            >
                                <multiSelectWithService
                                    :id="'filter-user'"
                                    ref="userMultiselect"
                                    v-model="filters.user"
                                    :service="'users'"
                                    :searchable="true"
                                    :multiple="false"
                                    :parameters="usersParameters"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <div class="col-sm-4 align-self-center">
                    <div class="d-flex justify-content-end">
                        <button
                            type="button"
                            class="btn btn-pdv btn-pdv-blue col-md-6 "
                            href="javascript: void(0);"
                            :disabled="loading"
                            @click="showExportKmModal">
                            <i class="fe-download mr-1"></i>
                            Gerar Relatório de KM
                        </button>
                        <filter-button class="col-md-6" @onClick="filter" />
                    </div>
                </div>
            </div>
        </div>
        <b-row>
            <b-col cols="12" style="position: relative; height: 60vh;">
                <gmap-map
                    ref="gmap"
                    :center="center"
                    :zoom="4"
                    :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: true,
                        disableDefaultUi: false,
                        maxZoom: 18,
                    }"
                    style="width: 100%; height: 100%"
                >
                <GmapMarker
                    v-if="userPosition && userPosition.lat && userPosition.lng"
                    :position="userPosition"
                    :icon="homeMarker"
                />
                <!-- <GmapMarker
                    v-for="posCheck in posChecks"
                    :key="posCheck.id + '_check_in'"
                    :position="posCheck.position"
                    :clickable="true"
                    :icon="checkInMarker"
                    :options="{ info: posCheck }"
                    @click="toggleInfoWindow(posCheck)"
                /> -->
                <GmapMarker
                    v-for="pos in pointOfSalesWithLocation"
                    :key="pos.id + '_pos'"
                    :position="pos.position"
                    :clickable="pos.point_of_sales_checks_count > 0"
                    :icon=" pos.point_of_sales_checks_count > 0 ? posVisitedMarker : posMarker"
                    :options="{ info: pos }"
                    @click="toggleInfoWindow(pos)"
                />
                <!-- Rota Prevista (azul) - usando resposta completa otimizada -->
                <DirectionsRenderer
                    v-if="showPredictedRoute && predictedRouteResponse"
                    :key="'predicted_route'"
                    :directions="predictedRouteResponse"
                    :polyline-options="{
                        strokeColor: '#4285F4',
                        strokeWeight: 4,
                        strokeOpacity: 0.8
                    }"
                />
                <!-- Rota Realizada (verde) - usando resposta completa -->
                <DirectionsRenderer
                    v-if="showPerformedRoute && performedRouteResponse"
                    :key="'performed_route'"
                    :directions="performedRouteResponse"
                    :polyline-options="{
                        strokeColor: '#34A853',
                        strokeWeight: 4,
                        strokeOpacity: 0.8
                    }"
                />
                </gmap-map>
                <!-- Controles customizados de rotas -->
                <div
                    v-if="user"
                    id="route-controls"
                    style="position: absolute; top: 10px; left: 20px; z-index: 1; min-width: 180px; padding: 6px 8px; font-family: Roboto, Arial, sans-serif; background: white; border-radius: 2px; box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;"
                >
                    <div style=" margin-bottom: 6px; font-size: 11px;font-weight: 500; color: #5f6368; text-transform: uppercase; letter-spacing: 0.5px;">Rotas</div>
                    <label style="display: flex; align-items: center; margin-bottom: 4px; font-size: 13px; color: #202124; cursor: pointer; user-select: none;">
                        <input
                            v-model="showPredictedRoute"
                            type="checkbox"
                            style=" width: 16px; height: 16px;margin-right: 8px; cursor: pointer;"
                        />
                        <span style="display: inline-block; flex-shrink: 0; width: 20px; height: 3px; margin-right: 8px; background-color: #4285F4; border-radius: 1px;"></span>
                        <span style="line-height: 1.4;">Rota Prevista</span>
                    </label>
                    <label style="display: flex; align-items: center; font-size: 13px; color: #202124; cursor: pointer; user-select: none;">
                        <input
                            v-model="showPerformedRoute"
                            type="checkbox"
                            style=" width: 16px; height: 16px;margin-right: 8px; cursor: pointer;"
                        />
                        <span style="display: inline-block; flex-shrink: 0; width: 20px; height: 3px; margin-right: 8px; background-color: #34A853; border-radius: 1px;"></span>
                        <span style="line-height: 1.4;">Rota Realizada</span>
                    </label>
                </div>
            </b-col>
        </b-row>

        <div v-if="user" class="card card-pdv mt-3">
            <PageHeader :title="user ? user.name : ''" />
            <div v-if="loading" class="card-body">
                <b-row class="ml-1">
                    <b-skeleton width="100%"></b-skeleton>
                </b-row>
                <b-skeleton-table
                :rows="5"
                :columns="workSchedulesFields.length"
                :table-props="{ hover: true, stickyHeader: true }"
                />
            </div>
            <div v-else class="card-body">
                <b-row class="ml-1">
                    {{ getI18n(i18nKey, 'TITLES.total_distance_predicted') }}:
                    {{ lodashRound(totalPredicted.distance / 1000, 3).toLocaleString('pt-BR') }} km ({{ `${Math.round(totalPredicted.duration / 60)} ${i18nMinutes}` }})
                    | {{ getI18n(i18nKey, 'TITLES.total_distance_performed') }}:
                    {{ lodashRound(totalPerformed.distance / 1000, 3).toLocaleString('pt-BR') }} km ({{ `${Math.round(totalPerformed.duration / 60)} ${i18nMinutes}` }})
                </b-row>

                <b-alert
                    v-if="pointOfSalesWithoutLocation.length > 0"
                    show
                    variant="warning"
                    class="mt-3">
                    <i class="fe-alert-triangle mr-1"></i>
                    Existem {{ pointOfSalesWithoutLocation.length }} PDV(s) sem localização cadastrada
                </b-alert>

                <data-mode-vuetable-pagination
                    ref="relationVuetable"
                    v-model="workSchedules"
                    :fields="workSchedulesFields"
                    :per-page="1000"
                >
                    <!-- <template slot="distance_from_last_point" slot-scope="props">
                        {{ lodashRound(props.rowData.distance_from_last_point / 1000, 3).toLocaleString('pt-BR') }} km
                    </template> -->
                    <template slot="distance_performed" slot-scope="props">
                        <span v-if="props.rowData.accomplished || (props.rowData.id === 0 && props.rowData.distance_performed > 0)">
                            {{ lodashRound(props.rowData.distance_performed / 1000, 3).toLocaleString('pt-BR') }} km
                        </span>
                        <span v-else>-</span>
                    </template>
                    <template slot="photo_checkin" slot-scope="props">
                        <a v-if="props.rowData.photo_checkin && props.rowData.photo_checkin.url"
                            :href="props.rowData.photo_checkin.url"
                            target="_blank">
                            <i class="fe-camera ml-1"/>
                        </a>
                        <i v-else class="fe-camera-off ml-1" />
                    </template>
                </data-mode-vuetable-pagination>

                <div v-if="pointOfSalesWithoutLocation.length > 0" class="mt-4">
                    <h5>PDVs sem localização cadastrada</h5>
                    <div class="table-responsive">
                        <table class="table table-centered table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>Nome do PDV</th>
                                    <th>Endereço</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="pos in pointOfSalesWithoutLocation" :key="pos.id">
                                    <td>{{ pos.pointOfSale.name }}</td>
                                    <td>{{ pos.pointOfSale.long_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <trackMapModal ref="trackModal" />
        <export-km-modal ref="exportKmModal" />
    </Layout>
</template>
